module.exports = __webpack_public_path__ + "img/adapt-menu.6cb3e2f0.svg";